import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {UrlQueryService} from '../../../../common/url-query/url-query.service';
import {OfflineNetworkApiService} from '../network/offline-network-api.service';
import {ConnectionFilterService} from '../../../../../network/utils/filters/connection/connection-filter.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineConnectionApiService {

  constructor(private http: HttpClient,
              private offlineNetworkApiService: OfflineNetworkApiService) {}

  readonly connectionUrl: string = 'planning/connection';

  public getConnectionsForMap(params: any = {}): Promise<any> {
    return this.offlineNetworkApiService.getOfflineMap().pipe(map((mapData: any) => {
      const connections = this.objectToArray(mapData.connections);
      return this.filterConnections(connections, params);
    })).toPromise();
  }

  public getConnectionForMap(id: number): Promise<any> {
    return this.offlineNetworkApiService.getOfflineMap().pipe(map((mapData: any) => {
      return mapData.connections[id];
    })).toPromise();
  }

  public getConnections(params): Promise<any> {
    const url = UrlQueryService.addQueryParameters(this.connectionUrl, {filter: params});
    return this.http.get(url).toPromise();
  }

  public getConnection(id: number): Promise<any> {
    return this.http.get(`${this.connectionUrl}/${id}`).toPromise();
  }


  public editConnection(connection: any, id: number): Promise<any> {
    const url = `${this.connectionUrl}/${id}`;
    return this.http.put(url, connection).toPromise();
  }

  public addConnection(connection: any): Promise<any> {
    return this.http.post(this.connectionUrl, connection).toPromise();
  }

  public deleteConnection(id: number): Promise<any> {
    const url = `${this.connectionUrl}/${id}`;
    return this.http.delete(url).toPromise();
  }

  private objectToArray(object): any {
    const array = [];

    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        if (object[key].type !== 'LOOP_BACK') {
          array.push(object[key]);
        }
      }
    }

    return array;
  }

  private filterConnections(connections, params): any {
    return (params && params.mapFilter) ?
      ConnectionFilterService.mapFilter(connections, params.searchObject) : connections;
  }
}
